import './orderTotalsLineItem.scss';

export const OrderTotalsLineItem = angular
    .module('checkout.components.orderSummary.orderTotalsLineItem', [])
    .component('orderTotalsLineItem', {
        template: `
            <div
                layout 
                layout-align="space-between start"
                class="order-totals-line-item"
                ng-class="{'order-totals-line-item--bold': $ctrl.bold}">
                <div class="order-totals-line-item__title">{{$ctrl.titleText}}</div>
                <div class="order-totals-line-item__value">{{$ctrl.valueText || '-'}}</div>
            </div>
        `,
        bindings: {
            titleText: '@',
            valueText: '@',
            bold: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/orderSummary/components/orderTotals/orderTotalsLineItem.js